
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "../../../assets/css/ClientsSection.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const clientsData = [
  {
    name: "Client 1",
    logo: `${BACKEND_URL}upload/other_agencies/others_01.jpg`,
  },
  {
    name: "Client 2",
    logo: `${BACKEND_URL}upload/other_agencies/others_02.jpg`,
  },
  {
    name: "Client 3",
    logo: `${BACKEND_URL}upload/other_agencies/others_03.jpg`,
  },
  {
    name: "Client 4",
    logo: `${BACKEND_URL}upload/other_agencies/others_04.jpg`,
  },
  {
    name: "Client 5",
    logo: `${BACKEND_URL}upload/other_agencies/others_05.jpg`,
  },
  {
    name: "Client 6",
    logo: `${BACKEND_URL}upload/other_agencies/others_06.jpg`,
  },
  {
    name: "Client 7",
    logo: `${BACKEND_URL}upload/other_agencies/others_07.jpg`,
  },
  {
    name: "Client 8",
    logo: `${BACKEND_URL}upload/other_agencies/others_08.jpg`,
  },
  {
    name: "Client 9",
    logo: `${BACKEND_URL}upload/other_agencies/others_09.jpg`,
  },
  {
    name: "Client 10",
    logo: `${BACKEND_URL}upload/other_agencies/others_10.jpg`,
  },
];

function ClientsSection() {
  return (
    <section
      id="clients"
      className="clients-section section"
      aria-labelledby="clients-section-title"
    >
      <div className="container">
        <div className="clients-section-heading">
          {/* <span className="clients-section-eyebrow">
            Collaboration & Partnership
          </span> */}

          <h2 id="clients-section-title">
            Our Agencies
          </h2>

          <span className="clients-section-divider" />

          {/* <p>
            Working together with institutions and agencies to advance
            sustainable development and deliver better public services.
          </p> */}
        </div>

        <div className="clients-carousel-wrapper">
          <Swiper
            modules={[Autoplay]}
            className="clients-swiper"
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            speed={700}
            spaceBetween={18}
            slidesPerView={2}
            breakpoints={{
              480: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              576: {
                slidesPerView: 3,
                spaceBetween: 22,
              },
              768: {
                slidesPerView: 4,
                spaceBetween: 24,
              },
              992: {
                slidesPerView: 5,
                spaceBetween: 24,
              },
              1200: {
                slidesPerView: 6,
                spaceBetween: 26,
              },
            }}
          >
            {clientsData.map((client) => (
              <SwiperSlide key={client.name}>
                <div className="clients-logo-card">
                  <div className="clients-logo-frame">
                    <img
                      src={client.logo}
                      loading="lazy"
                      decoding="async"
                      alt={client.name}
                      className="clients-logo-image"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="clients-section-footer">
          <span className="clients-footer-line" />
          <span>Fostering Strategic Partnerships for National Growth</span>
          <span className="clients-footer-line" />
        </div>
      </div>
    </section>
  );
}

export default React.memo(ClientsSection);
